<template>
  <div class="catalog-form">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action d-none d-lg-block" title="Refrescar registro para obtener las últimas actualizaciones" v-if="canReadItem" @click="loadItem" variant="outline-info"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action d-none d-lg-block" title="Modificar" v-if="canModifyItem" @click="modifyItem" variant="outline-secondary"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action d-none d-lg-block" title="Desactivar" v-if="canDeleteItem" @click="deleteItem" variant="outline-secondary"><i class="fal fa-trash-alt"></i> Desactivar</div>

        <div class="action d-lg-none d-sm-block" title="Refrescar registro para obtener las últimas actualizaciones" v-if="canReadItem" @click="loadItem" variant="outline-info"><i class="fal fa-sync"></i></div>
        <div class="action d-lg-none d-sm-block" title="Modificar" v-if="canModifyItem" @click="modifyItem" variant="outline-secondary"><i class="fal fa-file-edit"></i></div>
        <div class="action d-lg-none d-sm-block" title="Desactivar" v-if="canDeleteItem" @click="deleteItem" variant="outline-secondary"><i class="fal fa-trash-alt"></i></div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#subgroups" class="list-group-item list-group-item-action" aria-current="true">
          Subgrupos
        </a>
        <a href="#users" class="list-group-item list-group-item-action" aria-current="true">
          Usuarios
        </a>
        <a href="#projects" class="list-group-item list-group-item-action" aria-current="true">
          Proyectos
        </a>
        <a v-if="id" href="#history" class="list-group-item list-group-item-action" aria-current="true">
          Actualizaciones
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-group-name"
              label="Nombre *"
              label-for="input-name">
                <b-form-input
                  id="input-project-name"
                  name="input-project-name"
                  type="text"
                  class="shadow-none"
                  placeholder="Nombre del grupo"
                  v-model.trim="form.name"
                  v-validate="{ required: true }"
                  :state="validateState('input-project-name')"
                  aria-describedby="input-project-name-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <small class="text-muted" v-if="form.id"> ID Grupo: {{form.id}} </small>
                <b-form-invalid-feedback id="input-project-name-feedback">Nombre requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="select-group-domain"
                label="Dominio *"
                label-for="select-domain">
                <b-form-select
                  id="select-domain"
                  class="shadow-none"
                  name="select-domain"
                  v-model="form.domain.id"
                  :options="domains"
                  :disabled="!canReadDomains || readOnly"
                  @change="initNewItem">
                </b-form-select>
                <small class="text-muted"> ID Dominio: {{form.domain.id}} </small>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- GRUPOS PERTENECIENTES -->
        <b-card id="subgroups" header="Subgrupos relacionados" class="form-section users-groups">
          <div v-if="localGroups.length">
            <SubGroupSelectionTreeItem v-for="it in localGroups" :id="id" :key="it.id" :group="it" :root="true" :readOnly="readOnly" @select="updateSelectedGroups"/>
          </div>
          <div v-else>Sin grupos para relacionar</div>
        </b-card>

        <!-- USUARIOS RELACIONADOS -->
        <b-card id="users" header="Usuarios relacionados" class="form-section">
          <ItemsTable
            v-show="!loadingUsers"
            :available="!readOnly"
            :itemType="'Usuarios'"
            :items="relatedUsers"
            :mainItemColumns="fields"
            :mainAction="'remove'"
            :allItems="allUsers"
            :canAddItems="canAddUsers"
            @load-items="callLoadUsers"
            @update-items="updateUsers"
            @delete-items="removeUsers"
            ></ItemsTable>
        </b-card>

        <!-- PROYECTOS RELACIONADOS -->
        <b-card id="projects" header="Proyectos relacionados" class="form-section">
          <ItemsTable
            v-show="!loadingProjects"
            :available="!readOnly"
            :itemType="'Proyectos'"
            :items="relatedProjects"
            :mainItemColumns="fields"
            :mainAction="'remove'"
            :allItems="allProjects"
            :canAddItems="canReadProjects"
            @load-items="callLoadProjects"
            @update-items="updateProjects"
            @delete-items="removeProjects"
            ></ItemsTable>
        </b-card>

        <!-- ACTUALIZACIONES -->
        <b-card id="history" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '---' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '---' }}</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right" v-if="!readOnly">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar Grupo</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { BasicEntity, UserCatalogFilters, UserCatalogGridItem, User, DomainCatalogFilters, Domain } from '@/types/Catalogs'
import { Project, ProjectCatalogFilters, ProjectCatalogGridItem } from '@/types/catalogs/Projects'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import ItemsTable from '@/components/generic/ItemsTable.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import SubGroupSelectionTreeItem from '@/components/generic/SubGroupSelectionTreeItem.vue'
import catalogsService from '@/services/CatalogsService'
import { PermissionNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest } from '@/types/Support'
import { GroupCatalogFilters, GroupEntity, GroupStatus } from '@/types/catalogs/Groups'
import DateFormat from '@/services/DateFormat'
import LogService, { ToString } from '@/services/support/LogService'

@Component({
  components: {
    LoadingMask,
    MessageError,
    SubGroupSelectionTreeItem,
    ItemsTable
  }
})
export default class AdminGroupForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false })
  canAddUsers: boolean

  @Prop({ required: false })
  canReadProjects: boolean

  groups: GroupEntity[] = []
  loadingGroups: boolean = false
  localGroups: GroupEntity[] = []
  localGroupIds: number[] = []
  selectedGroupsIds: Set<number> = new Set<number>()
  loading: boolean = false

  PAGE_SIZE = 500
  formBackup = ''
  form = GroupEntity.getInstanceForEdit()
  filters = new GroupCatalogFilters()
  creationDate = ''
  updateDate = ''
  loadingDomains: boolean = false
  domains: any[] = []
  loadingUsers: boolean = false
  loadingProjects: boolean = false
  allUsers: UserCatalogGridItem[] = []
  allProjects: ProjectCatalogGridItem[] = []
  userIds: number[] = []
  projectIds: number[] = []
  fields = [
    { key: 'id', label: 'ID', sortable: true, thClass: 'smallColumnWidth' },
    { key: 'name', label: 'Nombre', sortable: true },
    { key: 'actions', label: 'Acciones' }
  ]

  /**
   * Loads form values in Vue mounted lifecycle
   */
  async mounted () {
    if (this.id) {
      await this.loadItem()
    } else {
      this.form.domain.id = userInfoStore.userInfo.domain.id
    }
    this.initDomain()
    this.callLoadGroups()
  }

  /**
   * Sets the list of subgroup ids delow the current group hierarchy.
   * This list includes the current group id if it has subgroups,
   * otherwise the list is empty
   *
   * @param group the current root group
   */
  setAllSubgroups (group: GroupEntity) {
    let allSubgroupIds: number[] = []
    allSubgroupIds.push(group.id)
    group.allSubgroupIds = allSubgroupIds
    if (group.subGroups.length <= 0) {
      return allSubgroupIds
    }
    group.subGroups.forEach(subg => {
      if (group.allSubgroupIds === undefined) group.allSubgroupIds = []
      group.allSubgroupIds = group.allSubgroupIds.concat(this.setAllSubgroups(subg))
    })
    return group.allSubgroupIds
  }

  /**
   * Sets sibling groups ids list between subgroups
   * @param group - root group
   */
  setSiblings (group: GroupEntity) {
    let subgroupIds = group.subGroups.reduce((arr: number[], it: BasicEntity) => arr.concat(it.id), [])
    group.subGroups.forEach(subgroup => {
      subgroup.siblingIds = subgroupIds
      if (this.localGroupIds.includes(subgroup.id)) {
        this.updateBrothersInLocalGroups(subgroup)
      }
      this.setSiblings(subgroup)
    })
  }

  /**
   * Sets the sibling list of a group object to the group entity
   * in localGroups variable to have all local groups sincronize
   * with the largest sibling list.
   * This will be used to restrict the available subgroups to
   * the group 'group'
   * @param group - from where compares the sibling list
   */
  updateBrothersInLocalGroups (group: GroupEntity) {
    this.localGroups.forEach(gr => {
      // When the matches by group id and sibling list are larger than
      // the current local sibling list
      if (gr.id === group.id &&
          (gr.siblingIds === undefined ||
          (gr.siblingIds && group.siblingIds && gr.siblingIds.length < group.siblingIds.length))) {
        gr.siblingIds = group.siblingIds
      }
    })
  }

  /**
   * Initializes the the records related with empty lists
   */
  async initNewItem () {
    this.callLoadGroups()
    this.form.users = []
    this.form.projects = []
    this.setSelectedGroups(this.groups, [])
  }

  /**
   * Calls GET group request by id to API
   * and initialize the form values
   */
  async loadItem () {
    this.loading = true
    await catalogsService.getGroupById(this.id).then((data: GroupEntity) => {
      Object.assign(this.form, data)
      this.userIds = this.form.users.reduce((arr: number[], it: BasicEntity) => arr.concat(it.id), [])
      this.projectIds = this.form.projects.reduce((arr: number[], it: BasicEntity) => arr.concat(it.id), [])
      this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
      this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
      this.formBackup = JSON.stringify(this.form)
    }).catch((error) => {
      this.loading = false
      if (error.response) {
        this.handleError(error, 'Error al cargar el grupo')
      } else {
        LogService.error(`Error en la cargar de grupo: ${ToString(error.response)}`)
      }
      this.onCancel()
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Initialize the status of the selected groups
   */
  initItemGroups () {
    const selectedIds = this.form.subGroups.reduce((arr: number[], it: BasicEntity) => arr.concat(it.id), [])
    this.setSelectedGroups(this.localGroups, selectedIds)
    this.selectedGroupsIds = new Set(selectedIds)
  }

  /**
   * Gets the current selected groups
   * @param groups list to get the activated groups
   */
  getSelectedGroups (groups: GroupEntity[]): GroupEntity[] {
    let groupsObjects: GroupEntity[] = []
    groups.forEach(it => {
      if (it._selected) groupsObjects.push(it)
      if (it.subGroups && it.subGroups.length) groupsObjects = groupsObjects.concat(this.getSelectedGroups(it.subGroups))
    })
    return groupsObjects
  }

  /**
   * Active the status of the groups based on list of active ids
   * @param groups to set status 'selected' or not
   * @param selectedIds which groups wll be activted
   */
  setSelectedGroups (groups: GroupEntity[], selectedIds: number[]) {
    groups.forEach(it => {
      selectedIds.indexOf(it.id) > -1 ? Vue.set(it, '_selected', true) : Vue.set(it, '_selected', false)
      if (it.subGroups && it.subGroups.length) this.setSelectedGroups(it.subGroups, selectedIds)
    })
  }

  /**
   * Update _selected status for each localGroups based on last group
   * that was actived as checkbox
   * @param group last group checked
   */
  updateSelectedGroups (group: GroupEntity) {
    let groups = this.getSelectedGroups(this.localGroups).reduce((arr: number[], it: GroupEntity) => arr.concat(it.id), [])
    this.selectedGroupsIds = new Set(groups)
    if (!group._selected) {
      this.selectedGroupsIds.delete(group.id)
    } else {
      this.selectedGroupsIds.add(group.id)
    }
    this.setSelectedGroups(this.localGroups, Array.from(this.selectedGroupsIds))
  }

  /** Permissions */

  /**
   * Check if user has 'permission' permission
   * @param permission name to check
   */
  hasPermission (permission: string) {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === permission)
  }

  /**
   * Checks if user can read the item
   */
  get canReadItem () {
    return this.id && this.readOnly && this.hasPermission(PermissionNames.GROUPS_READ)
  }

  /**
   * Checks if user can modify the item
   */
  get canModifyItem () {
    return this.id && this.readOnly &&
      this.hasPermission(PermissionNames.GROUPS_UPDATE) &&
      this.form.status !== GroupStatus.INACTIVE
  }

  /**
   * Checks if user can delete the item
   */
  get canDeleteItem () {
    return this.id && this.readOnly &&
      this.hasPermission(PermissionNames.GROUPS_DELETE) &&
      this.form.status !== GroupStatus.INACTIVE
  }
  /**
   * Checks if the user can select the domain value
   */
  get canReadDomains () {
    return userInfoStore.inRootDomain() && this.hasPermission(PermissionNames.DOMAINS_READ)
  }

  /** CRUD */

  /**
   * Submits form values to save changes with a PUT/POST request
   */
  onSubmit () {
    this.$validator.validateAll().then((result) => {
      if (result) {
        // Get changes from selected groups
        this.form.subGroups = this.getSelectedGroups(this.groups)
        if (JSON.stringify(this.form) === this.formBackup) {
          // If there are no changes then return to main grid
          this.onCancel()
          return false
        }
        this.saveGroup(this.form)
      } else {
        this.$bvToast.toast('Revise los campos marcados con error', {
          title: 'Errores en el formulario',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4500
        })
      }
    })
  }

  /**
   * Loads all the group records by api
   *
   * @param pageRequest configurations for the request
   */
  async loadGroups (pageRequest: PageRequest<GroupCatalogFilters>) {
    this.loadingGroups = true
    await catalogsService.getGroups(pageRequest)
      .then((response) => {
        this.groups = response.results
      })
      .catch((error) => {
        this.handleError(error, 'Error en carga de grupos')
      })
      .finally(() => { this.loadingGroups = false })
  }

  /**
   * Loads all the domain records to can select
   *
   * @param pageRequest configurations for the domains request
   */
  async loadDomains (pageRequest: PageRequest<DomainCatalogFilters>) {
    this.loadingDomains = true
    pageRequest.sort = 'name'
    await catalogsService.getDomains(pageRequest)
      .then((response) => {
        this.domains.push(
          ...response.results.map((domain: Domain) => {
            return { text: domain.name, value: domain.id }
          })
        )
        if (this.domains.length < response.total) {
          pageRequest.page++
          this.loadDomains(pageRequest)
        }
      })
      .catch((error) => {
        this.handleError(error, 'Error an carga de dominios')
      })
      .finally(() => { this.loadingDomains = false })
  }

  /**
   * Initialize the domain for the form
   */
  async initDomain () {
    if (userInfoStore.inRootDomain() && !this.readOnly) {
      await this.loadDomains(new PageRequest<DomainCatalogFilters>(this.PAGE_SIZE))
    } else {
      let userDomain = userInfoStore.userInfo.domain
      this.domains.push({ text: userDomain.name, value: userDomain.id })
    }
    if (this.domains.findIndex(domain => domain.value === this.form.domain.id) === -1) {
      this.domains.push({ text: this.form.domain.name, value: this.form.domain.id })
    }
  }

  /**
   * POST/PUT request to save the form values
   */
  saveGroup (group: GroupEntity) {
    this.loading = true
    catalogsService.saveGroup(group).then((response: GroupEntity) => {
      this.form.id = response.id
      this.$emit('saved')
    }).catch((error) => {
      this.handleError(error, 'Error al guardar el grupo.')
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Emit event to modify item
   */
  modifyItem () {
    this.$emit('modify-item')
  }

  /**
   * Emit event to delete item
   */
  deleteItem () {
    this.$emit('delete-item')
  }

  /**
   * Close form view
   */
  onCancel () {
    this.$emit('close')
  }

  /**
   * Checks if any form fields launchs an error
   */
  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  /**
   * Lauch error
   * @param error - error from users API action
   * @param title - to describe btoast
   */
  handleError (error: Error, title?: string) {
    let messageValues = {
      title: title,
      message: '',
      delay: 10000,
      error: error
    }
    let errorComponent = new MessageError({ propsData: messageValues })
    errorComponent.displayMessage()
  }

  /** Related users */

  /**
   * Get all users available and assign it in 'allUsers'
   */
  loadUsers (pageRequest: PageRequest<any>) {
    this.loadingUsers = true
    catalogsService.getUsers(pageRequest).then(response => {
      this.allUsers.push(...response.results.map((user: User): UserCatalogGridItem => {
        return { id: user.id, name: user.name } as UserCatalogGridItem
      }))
      if (this.allUsers.length < response.total) {
        pageRequest.page++
        this.loadUsers(pageRequest)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de usuarios: ${ToString(error.response)}`)
      this.loadingUsers = false
    }).finally(() => {
      this.loadingUsers = false
    })
  }

  /**
   * Returns related roles from form
   */
  get relatedUsers () {
    let users: any[] = []
    users = users.concat(this.form.users)
    if (this.allUsers.length > 0) {
      this.allUsers.forEach(user => {
        if (!users.find(u => u.id === user.id) && this.userIds.includes(user.id)) {
          users.push(user)
        }
      })
    }
    return users
  }

  /**
   * Configurations for a page request to get the group records
   *
   * @returns a PageRequest<GroupCatalogFilters>
   */
  prepareGroupRequest () {
    let pageRequest = new PageRequest<GroupCatalogFilters>()
    pageRequest.sort = 'name'
    pageRequest.filters.loadRelations = true
    if (userInfoStore.inRootDomain()) {
      pageRequest.filters.domain = this.form.domain.id
    }
    pageRequest.filters.status = GroupStatus.ACTIVE
    return pageRequest
  }

  /**
   * Prepares the page request to get the groups
   * and call the function to get them
   */
  async callLoadGroups () {
    this.groups = []
    let pageRequest = this.prepareGroupRequest()
    await this.loadGroups(pageRequest)
      .then(() => {
        // Create the items to select
        this.localGroups = this.groups
        this.localGroupIds = this.groups.reduce(
          (arr: number[], group: GroupEntity) => arr.concat(group.id), [])
        this.localGroups.forEach(group => {
          this.setAllSubgroups(group)
          this.setSiblings(group)
        })
      })
      .then(() => {
        // Active the items already selected
        this.initItemGroups()
      })
  }

  /**
   * Call loadUsers function
   */
  callLoadUsers () {
    this.allUsers = []
    let pageRequest = new PageRequest<UserCatalogFilters>(this.PAGE_SIZE)
    if (userInfoStore.inRootDomain()) {
      pageRequest.filters.domainId = this.form.domain.id
    }
    this.loadUsers(pageRequest)
  }

  /**
   * Updates user ids on emit action from ItemsTable
   * @param newUsers that will be added
   */
  updateUsers (newUsers: number[]) {
    this.userIds = this.userIds.concat(newUsers)
    this.form.users = this.allUsers.filter(user => this.userIds.includes(user.id))
  }

  /**
   * Remove user ids that was selected
   * @param users that must remove
   */
  removeUsers (users: number[]) {
    this.userIds = this.userIds.filter(id => !users.includes(id))
    this.form.users = this.form.users.filter(user => !users.includes(user.id))
  }

  /** Related projects */

  /**
   * Get all users available and assign it in 'allProjects'
   */
  loadProjects (pageRequest: PageRequest<any>) {
    this.loadingProjects = true
    catalogsService.getProjects(pageRequest).then(response => {
      this.allProjects.push(...response.results.map((project: Project): ProjectCatalogGridItem => {
        return { id: project.id, name: project.name } as ProjectCatalogGridItem
      }))
      if (this.allProjects.length < response.total) {
        pageRequest.page++
        this.loadProjects(pageRequest)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de proyectos: ${ToString(error.response)}`)
      this.loadingProjects = false
    }).finally(() => {
      this.loadingProjects = false
    })
  }

  /**
   * Returns related projects from form
   */
  get relatedProjects () {
    let projects: any[] = []
    projects = projects.concat(this.form.projects)
    if (this.allProjects.length > 0) {
      this.allProjects.forEach(proj => {
        if (!projects.find(p => p.id === proj.id) && this.projectIds.includes(proj.id)) {
          projects.push(proj)
        }
      })
    }
    return projects
  }

  /**
   * Call loadProjects function
   */
  callLoadProjects () {
    this.allProjects = []
    let pageRequest = new PageRequest<ProjectCatalogFilters>(this.PAGE_SIZE)
    if (userInfoStore.inRootDomain()) {
      pageRequest.filters.domain = this.form.domain.id
    }
    this.loadProjects(pageRequest)
  }

  /**
   * Updates projects ids on emit action from ItemsTable
   * @param newProjects that will be added
   */
  updateProjects (newProjects: number[]) {
    this.projectIds = this.projectIds.concat(newProjects)
    this.form.projects = this.allProjects.filter(project => this.projectIds.includes(project.id))
  }

  /**
   * Remove project ids that was selected
   * @param projects that must remove
   */
  removeProjects (projects: number[]) {
    this.projectIds = this.projectIds.filter(id => !projects.includes(id))
    this.form.projects = this.form.projects.filter(proj => !projects.includes(proj.id))
  }
}
</script>

<style lang="scss" scoped>
$white:    #fff !default;
$gray-100: #f8f9fa !default;

.users-groups{
  .group-root{
    background-image: linear-gradient($gray-100, $white);
    border-radius: 7px;
  }
}
</style>
